import React from "react";
import "./Button.css";

/* <Button
  value="Save"
  icon={<SaveIcon />}
  onClick={() => console.log("Clicked")}
  variant="primary"
/>

<Button
  value="Next"
  icon={<ArrowRight />}
  iconPosition="right"
/> */

const Button = ({
  value = "Button",
  onClick,
  disabled = false,
  style,
  className = "",
  type = "button",
  variant = "primary", // primary, primary-outlined, primary-text, dark-outlined
  icon = null, // <-- new prop
  iconPosition = "left", // "left" or "right"
}) => {
  const getButtonClass = (v) => {
    const base = "katch-form-button";

    const variantMap = {
      primary: `${base}--primary`,
      "primary-filled": `${base}--primary`,
      "primary-outlined": `${base}--primary-outlined`,
      "primary-text": `${base}--primary-text`,
      "dark-outlined": `${base}--dark-outlined`,
    };

    return `${base} ${variantMap[v?.toLowerCase()] || `${base}--primary`}`;
  };

  return (
    <button
      type={type}
      disabled={disabled}
      className={`${getButtonClass(variant)} ${className}`}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      {icon && iconPosition === "left" && (
        <span className="katch-button-icon katch-button-icon--left">
          {icon}
        </span>
      )}

      <span className="katch-button-text">{value}</span>

      {icon && iconPosition === "right" && (
        <span className="katch-button-icon katch-button-icon--right">
          {icon}
        </span>
      )}
    </button>
  );
};

export default Button;
